import { MatDialogConfig } from '@angular/material/dialog';
import { TransferProductModalData } from '../modals/transfer-product-modal/transfer-product-modal.component';
import { IProductResponse } from '../models/product.model';

export function createProductTransferDialogConfig(
  product: IProductResponse,
  currentDepartmentId: string
) {
  return {
    panelClass: ['no-padding', 'mobile-sizing-for-mat-dialogs'],
    width: product.isChemical ? '52rem' : '25rem',
    data: {
      productId: product.id,
      sourceDepartmentId: product.department?.id || product.departmentId || currentDepartmentId,
      productName: product.name,
      maxQuantity: product.quantity,
      isChemical: !!product.isChemical,
      manufacturerName: product.maker,
    },
  } satisfies MatDialogConfig<TransferProductModalData>;
}
